import '@features/Layout/Layout.scss';
import Footer from '@features/Layout/Footer/Footer';
import Navigation from '@features/Layout/Navigations/Navigation';
import SideNavigation from '@features/Layout/SideNavigation/SideNavigation';
import Background from './Background/Background';
import SearchFilter from './SearchFilter/SearchFilter';
import SubscriptionFilter from '@project/features/Layout/SubscriptionFilter/SubscriptionFilter';
import { useLocation } from 'react-router-dom';

interface LayoutProps {
  children: JSX.Element;
}

function Layout({ children }: LayoutProps) {

  const location = useLocation();

  return (
    <div>
      <Navigation />
      <main className="flex flex-row">
        <div className='flex'>
          <SideNavigation />
          {location.pathname == '/subscription/invoices' ?
            <SubscriptionFilter /> : <SearchFilter />
          }
        </div>
        <section className="right-content flex flex-column scrollable-right-content">
          <div className="page-content flex flex-column">
            {children}
            <Background />
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default Layout;
